import api from './api';

export interface TutorConversationMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface TutorQuickAction {
  id: string;
  label: string;
  prompt: string;
}

export interface AssignmentTutorReply {
  reply: string;
  topic: string;
  reminder: string;
  quickActions: TutorQuickAction[];
}

export const chatWithAssignmentTutor = async (
  assignmentId: number,
  payload: {
    message: string;
    conversationHistory?: TutorConversationMessage[];
    currentAnswers?: Array<string | string[]> | Record<string, unknown>;
    includeMaterialContext?: boolean;
  },
) => {
  const response = await api.post(`/student/assignment/${assignmentId}/tutor-chat`, payload);
  return response.data;
};